import _ from 'lodash';
import { SITEMAP } from '../../constants/ActionTypes';

const initialState = {
  error: null,
  loaded: false,
  loading: false,
  result: {},
};

/**
 * Sitemap Reducer
 * @param {*} state
 * @param {*} action
 */
export default function sitemap(state = initialState, action = {}) {
  switch (action.type) {
    case `${SITEMAP}_PENDING`:
      return {
        ...state,
        error: null, // state.error = null
        loaded: false, // state.loaded = false
        loading: true, // state.loading = true
      };
    case `${SITEMAP}_SUCCESS`:
      return {
        ...state,
        error: null,
        result: action?.result,
        loaded: true,
        loading: false,
      };
    case `${SITEMAP}_FAIL`:
      return {
        ...state,
        error: action.error,
        loaded: false,
        loading: false,
      };
    default:
      return state;
  }
}
